<template>
  <v-btn
    class="whatsapp"
    depressed
    text
    :href="$validate.DataValid(phone) ? `https://wa.me/852${phone}` : ''"
    target="_blank"
    :min-width="`${width}px`"
    :max-width="`${width}px`"
  >
    <v-icon size="24" color="white">{{ mdiWhatsapp }}</v-icon>
  </v-btn>
</template>

<script>
import { mdiWhatsapp } from '@mdi/js'
export default {
  name: 'FormButton',
  props: {
    phone: {
      type: String,
      required: true,
      default: '',
    },
    width: {
      type: String | Number,
      default: 57,
      required: false,
    },
  },
  data: () => ({
    mdiWhatsapp,
  }),
}
</script>
